import { render, staticRenderFns } from "./paymentConfig.vue?vue&type=template&id=2e4512de&scoped=true&"
import script from "./paymentConfig.vue?vue&type=script&lang=js&"
export * from "./paymentConfig.vue?vue&type=script&lang=js&"
import style0 from "./paymentConfig.vue?vue&type=style&index=0&id=2e4512de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4512de",
  null
  
)

export default component.exports